export default __webpack_public_path__ + "eject-symbol.png";